import { render, staticRenderFns } from "./dashboardModerationUnit.vue?vue&type=template&id=57c5c290&scoped=true&"
import script from "./dashboardModerationUnit.vue?vue&type=script&lang=js&"
export * from "./dashboardModerationUnit.vue?vue&type=script&lang=js&"
import style0 from "./dashboardModerationUnit.vue?vue&type=style&index=0&id=57c5c290&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c5c290",
  null
  
)

export default component.exports